import { HttpRequest } from "@/services/api/http";

export default new (class PositionLogsApi extends HttpRequest {
  constructor() {
    super();
  }

  public async createTags(tags: any) {
    return this.axiosClient.put(`/position_logs/tags`, tags);
  }

  public async updateTagPosition(tagId: number, tagInfo: any) {
    return this.axiosClient.put(`/position_logs/tag/${tagId}`, tagInfo);
  }

  public async getAnalyticsLogs(
    timestampStart: number,
    timestampEnd: number,
    shiftStart: number,
    shiftEnd: number,
    anchorIds?: Array<number>,
    routeInstanceId?: number,
    page?: number,
    pageSize?: number
  ) {
    const anchorIdsQuery =
      anchorIds && anchorIds.length > 0
        ? "?" + anchorIds.map(id => `anchor_ids=${id}`).join("&")
        : "";

    return this.axiosClient.get(
      `/position_logs/analytics/${timestampStart}/${timestampEnd}/${shiftStart}/${shiftEnd}${anchorIdsQuery}${"&page=" +
        page}${pageSize ? "&page_size=" + pageSize : ""}${
        routeInstanceId ? "&route_instance_id=" + routeInstanceId : ""
      }`
    );
  }

  public async getTripFrequency(
    timestampStart: number,
    timestampEnd: number,
    shiftStart: number,
    shiftEnd: number,
    anchorIds?: Array<number>,
    routeInstanceId?: number
  ) {
    const params = new URLSearchParams();

    params.append("timestamp_start", String(timestampStart));
    params.append("timestamp_end", String(timestampEnd));
    params.append("shift_start", String(shiftStart));
    params.append("shift_end", String(shiftEnd));

    if (anchorIds && anchorIds.length > 0) {
      anchorIds.forEach(id => params.append("anchor_ids", String(id)));
    }

    if (routeInstanceId) {
      params.append("route_instance_id", String(routeInstanceId));
    }

    return this.axiosClient.get(`/position_logs/trip_frequency/`, {
      params
    });
  }

  public async getAnchorPositionLogsFromTo(
    startTime: number,
    endTime: number,
    anchorIds?: Array<number>,
    startShift?: number,
    endShift?: number,
    routeInstanceId?: number
  ) {
    const anchorIdsQuery =
      anchorIds && anchorIds.length > 0
        ? "?" + anchorIds.map(id => `anchor_ids=${id}`).join("&")
        : "";

    return this.axiosClient.get(
      `/position_logs/histogram_values/${startTime}/${endTime}${
        startShift !== undefined ? `/${startShift}` : ""
      }${endShift ? `/${endShift}` : ""}${anchorIdsQuery}${
        routeInstanceId ? `&route_instance_id=${routeInstanceId}` : ""
      }
      `
    );
  }

  public exciterUpdateReplace(anchors: {
    anchorId: number;
    mapX: number;
    mapY: number;
  }) {
    return this.axiosClient.put(`/position_logs/exciters`, anchors);
  }

  public async getAnchorPositionLogs(payload: {
    timestampStart: number;
    timestampEnd: number;
    anchorIds: Array<number>;
  }) {
    const { timestampStart, timestampEnd, anchorIds } = { ...payload };
    const anchorIdsQuery =
      anchorIds && anchorIds.length > 0
        ? "?" + anchorIds.map(id => `anchor_ids=${id}`).join("&")
        : "";

    return this.axiosClient.get(
      `/position_logs/timeline/${timestampStart}/${timestampEnd}/${anchorIdsQuery}`
    );
  }
})();
